import Input from '../../../../Core/Fields/Floating/Input';
import Checkbox from '../../../../Core/Fields/Floating/Checkbox';
import SelectSearch from '../../../../Core/Fields/Floating/SelectSearch';
import Tab3Table1 from "./Tab3Table1";
import ActivityCard from "../../../../Core/Activity/ActivityCard";
import {
  useItemSupplierSearchByNameMutation
} from "../../../../store/api/itemapi";
const Tab3 = ({
  ItemCode,
  Default_Purchase_Unit_of_Measure,
  Safety_Stock,
  Minimum_Order_Qty,
  Lead_Time_in_days,
  Allow_Purchase,
  Is_Customer_Provided_Item,
  Country_of_Origin,
  CustomsTariffNumber,
  setselected_item_supplier_data,
  selected_item_supplier_data,
  Delivered_by_Supplier
}) => {
  const [ItemSupplierApi] = useItemSupplierSearchByNameMutation()
  return (
    <>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Purchasing Details</p>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <SelectSearch
              list={Default_Purchase_Unit_of_Measure.Default_Purchase_Unit_of_Measure_list}
              style={{
                height: "30px",
                border: Default_Purchase_Unit_of_Measure.Error ? "1px solid red" : "",
              }}
              label="Default Unit Of Measure"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={Default_Purchase_Unit_of_Measure.select_Default_Purchase_Unit_of_Measure}
              onChange={(val) => Default_Purchase_Unit_of_Measure.setselect_Default_Purchase_Unit_of_Measure(val)}
            />
          </div>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <Input
              id="Safety_Stock"
              label="Safety Stock"
              style={{ height: "30px" }}
              value={Safety_Stock.Safety_Stock}
              onChange={(e) => Safety_Stock.setSafety_Stock(e.target.value)}
            />
          </div>
        </div>
        <div className="col-6 ">
          <div className="mb-1">
            <Input
              id="Minimum_Order_Qty"
              label="Minimum Order Qty"
              style={{ height: "30px" }}
              value={Minimum_Order_Qty.Minimum_Order_Qty}
              onChange={(e) => Minimum_Order_Qty.setMinimum_Order_Qty(e.target.value)}
            />
            <p style={{
              paddingLeft: '14px',
              paddingRight: '14px',
              fontWeight: 400,
              fontSize: '9px',
              letterSpacing: '0',
              color: '#00000099', fontFamily: 'Roboto, sans-serif',
            }} >
              Minimum quantity should be as per Stock UOM
            </p>
          </div>
        </div>
        <div className="col-6">
          <div className="mb-1">
            <Input
              id="Lead_Time_in_days"
              label="Lead Time in days"
              style={{ height: "30px" }}
              value={Lead_Time_in_days.Lead_Time_in_days}
              onChange={(e) => Lead_Time_in_days.setLead_Time_in_days(e.target.value)}
            />
            <p style={{
              paddingLeft: '14px',
              paddingRight: '14px',
              fontWeight: 400,
              fontSize: '9px',
              letterSpacing: '0',
              color: '#00000099', fontFamily: 'Roboto, sans-serif',
            }} >
              Average time taken by the supplier to deliver
            </p>
          </div>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <Checkbox
              id="Allow_Purchase"
              label="Allow Purchase"
              value={Allow_Purchase?.Allow_Purchase || false}
              onChange={(val) => Allow_Purchase?.setAllow_Purchase?.(val)}
            />
          </div>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <Checkbox
              id="Is_Customer_Provided_Item"
              label="Is Customer Provided Item"
              value={Is_Customer_Provided_Item?.Is_Customer_Provided_Item || false}
              onChange={(val) => Is_Customer_Provided_Item?.setIs_Customer_Provided_Item?.(val)}
            />
          </div>
        </div>
      </div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Supplier Details</p>
        </div>
        <div className="col-4 ">
          <div className="mb-3">
            <Checkbox
              id="Delivered_by_Supplier"
              label="Delivered by Supplier (Drop Ship)"
              value={Delivered_by_Supplier?.Delivered_by_Supplier || false}
              onChange={(val) => Delivered_by_Supplier?.setDelivered_by_Supplier?.(val)}
            />
          </div>
        </div>
        <Tab3Table1 setselected_item_supplier_data={setselected_item_supplier_data} selected_item_supplier_data={selected_item_supplier_data} list_Supplier_data={ItemSupplierApi} />
      </div>
      <div
        className="row mb-3"
        style={{ border: "1px solid #00000059", borderRadius: "5px" }}
      >
        <div className="col-12">
          <p className="boxLabel m-0">Foreign Trade Details</p>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <SelectSearch
              list={Country_of_Origin.Country_of_Origin_list}
              style={{
                height: "30px",
                border: Country_of_Origin.Error ? "1px solid red" : "",
              }}
              label="Country of Origin"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={Country_of_Origin.select_Country_of_Origin}
              onChange={(val) => Country_of_Origin.setselect_Country_of_Origin(val)}
            />
          </div>
        </div>
        <div className="col-6 ">
          <div className="mb-3">
            <SelectSearch
              list={CustomsTariffNumber.CustomsTariffNumber_list}
              style={{
                height: "30px",
                border: CustomsTariffNumber.Error ? "1px solid red" : "",
              }}
              label="Customs Tariff Number"
              getOptionLabel={(item) => item.name} // 👈 Required
              getOptionValue={(item) => item.name} // 👈 Required
              value={CustomsTariffNumber.select_CustomsTariffNumber}
              onChange={(val) => CustomsTariffNumber.setselect_CustomsTariffNumber(val)}
            />

          </div>
        </div>
      </div>
       <div>
              <ActivityCard doctype={'Item'} docname={ItemCode.ItemCode} />
          </div>




    </>
  );
};

export default Tab3;